<template>
  <div :value="value" v-show="visible" @keyup.esc="visible=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="visible=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
              </div>
              <a class="btn-close" @click="visible = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
            	
              <div class="form-group">
              	<h4>聯絡人封存</h4>	
                <h5 class="alert alert-warning">
                  聯絡人離職後，可進行封存，請選擇永久封存 『聯絡人/公司』 之交易 或 將全部交易轉移至其他聯絡人<br>
                </h5>
              </div>
            </div>
            <div class="form-group" v-show="!delete_type">
	            <button class="btn btn-warning btn-lg" @click="delete_type='transfer'">
	              轉移交易，並封存聯絡人
	            </button>
            </div>
            <div class="form-group" v-show="delete_type=='transfer'">
	            <div class="input">
	              <label for="text">請輸入要移轉的聯絡人名稱，如果該聯絡人不存在，將會建立全新的聯絡人</label>
	              <autocomplete :url="axios.defaults.baseURL + '/settings/auto_complete'" anchor="name" label="organization_name" param="keyword" name="autocomplete" placeholder="輸入並選擇聯絡人*" v-model="contact_name" :classes="{ input: 'form-control  contact_name', wrapper: 'input-wrapper'}" :process="process_contact_JSON" :onSelect="handle_contact_Select" :onInput="set_contact_Value" :customHeaders=AuthToken :customParams="{ type: 'contact' }">
	              </autocomplete>
	            </div>
	          </div>
	          <p class="font-weight-bold" v-show="delete_type=='destroy'"><i class="glyphicon glyphicon-alert"></i> 永久封存後，將無法還原</p>	
            <div class="form-group" v-show="!delete_type">
	            <button class="btn btn-lg" @click="delete_type='destroy'">
	             	永久封存聯絡人與交易
	            </button>
            </div>
            <div class="modal-footer j-forms col-md-12" v-show="delete_type">
              <div name="footer">
                <button class="btn btn-primary" @click="deleteTarget">
                  確認
                </button>
                <button class="btn btn-primary" @click="visible=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import autocomplete from 'vue2-autocomplete-js'

export default {
  name: 'Modal',
  data () {
    return {
    	visible: false,
    	contact_name: '',
    	delete_type: ''
    }
  },
  components:{
  	autocomplete
  },
  props: {
  	value: {
  		type: Boolean,
  		default: false
  	},
  	AuthToken: '',
  	TargetToken: '',
    target: ''
  },
  watch:{
  	value(val){
  		this.visible = val
  	},
  	visible(val){
  		this.$emit('input', val)
  		this.delete_type = ''
  	}
  },
  mounted(){
  	if(this.value){
  		this.visible = true
  	}
  },
  methods:{
    deleteTarget(){
      var request_url = this.target+'/:id'
	    const vm = this;
	    this.axios.delete(request_url, {
	      params: {
	        target_token: vm.TargetToken,
	        new_contact_name: vm.contact_name,
    			delete_type: vm.delete_type
	      }
	    })
      .then(function(response) {
        if (response.status == 200) {
          vm.$router.push({ name: vm.target})
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    // AutoComplete callback function (Contact)
    process_contact_JSON(json) {
      return json.results.contact;
    },
    handle_contact_Select(data) {
      // if contact selected, disable input contact infos
      this.contact_name = data.name
      
    },
    set_contact_Value(value) {
      // if keyup contact name instead select, then should also input contact infos
      this.contact_name = value
    },
  }
}
</script>


// WEBPACK FOOTER //
// DeleteModal.vue?bc22bac4